import React from "react";
import image_1 from "../../images/agriculture/Picture2.webp";

const AboutUs = () => {
  return (
    <section id="about">
      <div className="agriculture-about-container">
        <div className="ms-13 me-13 pt-7 pb-7 text-center">
          <img src={image_1} className="img-fluid" alt="" />
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold text-white pt-5">
            About Us
          </h1>
        </div>
      </div>
      <div className="bg-chinese-black">
        <div className="me-47 ms-47 text-white pt-7 pb-7">
          <div>
            <h2 className="fs-28 gilroy-bold mb-5 text-orange-ryb">
              Fresh & Seasonal
            </h2>
            <p className="fs-18 lh-30 text-align-justify">
              Our Vision is to be the leading Egyptian brand of harvested foods,
              serving our exporters with a commitment to competitive and quality
              produce. Our high quality food products meets the standards
              demanded by consumers in the United States, Europe and the Middle
              East. We have developed fair – trade partnership with local
              farmers with commitment for quality seasonal produce from the
              fertile agricultural fields by investing in organic and
              environmentally friendly farming methods. We source only the
              finest raw materials are selected for processing to meet the
              requirements of the most discerning clients world-wide by keeping
              a strict ISO control regarding freshness and hygiene.
            </p>
          </div>

          <div>
            <h2 className="fs-28 gilroy-bold my-5 text-orange-ryb">
              Farm to Table
            </h2>
            <p className="fs-18 lh-30 text-align-justify">
              SEGAM Agriculture & Trade is a leading Egyptian company in
              producing, packing and exporting Egyptian Agricultural Crops. Our
              products like Citrus Fruits, Grapes, Pomegranates, Mango,
              Watermelon and all seasonal fruits as well as Vegetables like
              Iceberg Lettuce, Broccoli, Tomatoes, Potatoes, Cucumber, zucchini
              and other all Egyptian vegetables, and Dates This all beside herbs
              like dills, coriander, thyme and so on, we have our packing house
              for preparing our products to be ready for Exporting.
            </p>
          </div>

          <div>
            <h2 className="fs-28 gilroy-bold my-5 text-orange-ryb">
              Handle with Care
            </h2>
            <p className="fs-18 lh-30 text-align-justify">
              Our main Mission is getting satisfaction of our regular and new
              customers, because we are looking always for long term business,
              so we put our efforts as staff team work to provide and keep our
              products with very High quality, accurate weight net and gross.
              This all followed by discipline for shipping and arrival of items
              to our customers destinations. We deal with Sea, Air, Land freight
              it’s all depending on kind of exported items and customer desire.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
